import axios from './BaseService';

const API_URL = process.env.REACT_APP_API_URL;

const PADRAO_URL = `${API_URL}/pedidos/`;

export async function getPedidos(alias, page, token) {
    const PedidosUrl = `${PADRAO_URL}${alias}?page=${page}`;
    const headers = { 'authorization': token }

    console.log(PedidosUrl);
    const response = await axios.get(PedidosUrl, { headers });
    return response.data;
}

export async function getPedido(id, token) {
    const PedidosUrl = `${PADRAO_URL}id/${id}`;
    const headers = { 'authorization': token }

    console.log(PedidosUrl);
    const response = await axios.get(PedidosUrl, { headers });
    return response.data;
}


export async function getAllPedidos(token) {
    const headers = { 'authorization': token }
    const response = await axios.get(`${PADRAO_URL}all`, { headers });
    return response.data;
}

export async function getActivePedidos(token) {
    const headers = { 'authorization': token }
    const response = await axios.get(`${PADRAO_URL}active`, { headers });
    return response.data;
}


export async function savePedido(id, newPedido, token) {
    const headers = { 'authorization': token };
    let response;
    if (id)
        response = await axios.patch(`${PADRAO_URL}${id}`, newPedido, { headers });
    else
        response = await axios.post(PADRAO_URL, newPedido, { headers });
    return response.data;
}
